
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-2.857-21.143V9.43h5.714v1.428h-5.714zM26 18h-7.5v1.786a.72.72 0 01-.714.714h-3.572a.72.72 0 01-.714-.714V18H6v5.357c0 .982.804 1.786 1.786 1.786h16.428c.982 0 1.786-.804 1.786-1.786V18zm-8.571 0H14.57v1.429h2.858V18zM26 12.643c0-.982-.804-1.786-1.786-1.786h-3.928V9.071c0-.591-.48-1.071-1.072-1.071h-6.428c-.592 0-1.072.48-1.072 1.071v1.786H7.786c-.982 0-1.786.804-1.786 1.786v4.286h20v-4.286z"}})])
          )
        }
      }
    